<!-- Top bar -->
<mat-toolbar class="topBar">

  <!-- Back to Current Delivery -->
  <button mat-icon-button
          type="button"
          matTooltip='Back to Current Delivery'
          matTooltipPosition="above"
          [disabled]="isSubmitting"
          (click)="navigateBack()">     
    <mat-icon>
      arrow_back
    </mat-icon>
  </button>
  <span>Delivery Submission Review</span>
</mat-toolbar>

<mat-spinner *ngIf="isSubmitting" class="mat-spinner-color" [diameter]="200"
             style="position: absolute;
  z-index: 10000;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); color: #ff6f61;"></mat-spinner>

<mat-card *ngIf="!finalSubmit" style="margin: 10px; background-color: aliceblue;">
  <div class="container" style="display:flex; flex-direction: column; align-items: center;">

    <div class="row" style="padding-top: 15px;">
      <button mat-icon-button
              class="color-button-orange"
              type="button"
              (click)="finalSubmit = true">
        <mat-icon>
          cloud_upload
        </mat-icon>
      </button>
    </div>

    <div class="row">
      <h1 *ngIf="deliveryIndex == -1" class="display-1" style="color: #ff6f61;" align="center">Submit Logbook</h1>
      <h1 *ngIf="deliveryIndex != -1" class="display-1" style="color: #ff6f61;" align="center">Submit Edits to Logbook</h1>
    </div>
    
  </div>
  </mat-card>

  <mat-card *ngIf="!finalSubmit && fishery != 'Groundfish' && draftIndex == -1 && deliveryIndex == -1" style="margin: 10px; background-color: aliceblue;">
  <div class="container" style="display:flex; flex-direction: column; align-items: center;">
    <div class="row" style="padding-top: 15px;">
      <button mat-icon-button
              class="color-button-orange"
              type="button"
              (click)="saveDraft()">
        <mat-icon>
          save_as
        </mat-icon>
      </button>
    </div>

    <div class="row">
      <h1 class="display-1" style="color: #ff6f61;" align="center">Save Logbook as draft and start new trip</h1>
    </div>
    
  </div>
</mat-card>

<mat-card *ngIf="finalSubmit" style="margin: 10px; background-color: aliceblue;">
  <div class="container" style="display:flex; flex-direction: column; align-items: center; padding-top: 12px;">
    <h1 class="display-1" style="color: #ff6f61;" align="center">I certify under penalty of perjury that I have reviewed all the information in this form and that it is true and complete to the best of my knowledge.</h1>

    <!-- Submit delivery: step 2 -->
    <button mat-icon-button
            class="color-button-orange"
            type="submit"
            [disabled]="isSubmitting"
            (click)="submitToServer()">
      <mat-icon>
        cloud_upload
      </mat-icon>
    </button>

    <h1 class="display-1" style="color: #ff6f61;" align="center">Confirm and Submit</h1>
  </div>
</mat-card>



<div class="row" style="padding-top: 20px;">

  <table mat-table [dataSource]="catchItems" class="mat-elevation-z8" #catchTable>

    <!-- Species Name Column -->
    <ng-container matColumnDef="Species">
      <tr>
        <th mat-header-cell *matHeaderCellDef> Species </th>
        <td mat-cell *matCellDef="let item"> {{item.species.name}} </td>
      </tr>
    </ng-container>

    <ng-container matColumnDef="RetainedCount">
      <tr>
        <th mat-header-cell *matHeaderCellDef> Count - Retained </th>
        <td mat-cell *matCellDef="let item"> 
          {{item.retainedCount ?? '-'}} 
        </td>
      </tr>
    </ng-container>

    <ng-container matColumnDef="RetainedWeight">
      <tr>
        <th mat-header-cell *matHeaderCellDef> Weight - Retained </th>
        <td mat-cell *matCellDef="let item">
          {{item.retainedWeight ?? '-'}}
        </td>
      </tr>
    </ng-container>

    <ng-container matColumnDef="ReleasedCount">
      <tr>
        <th mat-header-cell *matHeaderCellDef> Count - Released </th>
        <td mat-cell *matCellDef="let item"> {{item.releasedCount ?? '-'}} </td>
      </tr>
    </ng-container>

    <ng-container matColumnDef="ReleasedWeight">
      <tr>
        <th mat-header-cell *matHeaderCellDef> Weight - Released </th>
        <td mat-cell *matCellDef="let item">
          {{item.releasedWeight ?? '-'}}
        </td>
      </tr>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="catchTableColumns"
        class="second-header-row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: catchTableColumns; let index=index;"></tr>
  </table>

</div>

<div class="row" style="padding: 15px;">
  @switch (fishery) {
    @case ("Groundfish") {
      <h2 class="display-6" style="border: 1px solid; border-radius: 5px;">Landing Date: <span>{{groundfishLanding.returnDate | date: 'fullDate'}}</span></h2>
    }
    @case ("HMS") {
      <h2 class="display-6" style="border: 1px solid; border-radius: 5px;">Arrival Date: <span>{{hmsLanding.arrivalDate | date: 'fullDate'}}</span></h2>
    }
    @case ("Trawl") {
      <h2 class="display-6" style="border: 1px solid; border-radius: 5px;">Return Date: <span>{{trawlLanding.returnDate | date: 'fullDate'}}</span></h2>
    }
  }
</div>

<div *ngIf="fishery == 'Groundfish'" class="row">
  <h2 class="display-6" style="padding-left: 20px; text-decoration: underline; font-weight: 400;">Included Sets:</h2>
  <div *ngFor="let set of groundfishLanding.sets" style="padding-left: 20px; padding-right: 20px; font-size: 16px;">
    <mat-card>
      <div class="container">
        <div class="row">
          <div class="col-5">
            <span *ngIf="set.setNumber == ''" style="font-size: small; font-weight: lighter; font-style: italic;">&lt;No String/Set#&gt;</span><b>{{set.setNumber}}</b>
          </div>
          <div class="col-6">
            <b>Set: </b>{{set.startDate | date:'HH:mm, EE, MMM.dd'}}
            <br>
            <b>Retrieval: </b>{{set.endDate | date:'HH:mm, EE, MMM.dd'}}
          </div>
        </div>
      </div>
      <mat-card-footer></mat-card-footer>
    </mat-card>
    <br>
  </div>
</div>

<div *ngIf="fishery == 'HMS'" class="row">
  <h2 class="display-6" style="padding-left: 20px; text-decoration: underline; font-weight: 400;">Included Sets:</h2>
  <div *ngFor="let set of hmsLanding.sets" style="padding-left: 20px; padding-right: 20px; font-size: 16px;">
    <mat-card style="height: 60px; justify-content: center;">
      <div style="display: flex; justify-content: space-around;">
        <span><b>Fishing Date: </b>{{set.startDate | date:'EEEE, MMM d, y'}}</span>
      </div>      
      <mat-card-footer></mat-card-footer>
    </mat-card>
    <br>
  </div>
</div>

<div *ngIf="fishery == 'Groundfish' || (fishery == 'Trawl' && !trawlLanding.atSeaDelivery)" class="row">
  <h2 class="display-6" style="padding-left: 20px; text-decoration: underline; font-weight: 400;">Fish Tickets</h2>
  <table mat-table [dataSource]="ticketData" class="mat-elevation-z8">

    <!-- Buyer Column  -->
    <ng-container matColumnDef="Buyer">
      <tr>
        <th mat-header-cell *matHeaderCellDef> Buyer </th>
        <td mat-cell *matCellDef="let tck"> {{tck.buyer}} </td>
      </tr>
    </ng-container>

    <!-- Fish Ticket # Column -->
    <ng-container matColumnDef="Fish Ticket Number">
      <tr>
        <th mat-header-cell *matHeaderCellDef> Fish Ticket Number </th>
        <td mat-cell *matCellDef="let tck"> {{tck.ticketNumber}} </td>
      </tr>
    </ng-container>

    <!-- Date Column -->
    <ng-container matColumnDef="Date">
      <tr>
        <th mat-header-cell *matHeaderCellDef> Date </th>
        <td mat-cell *matCellDef="let tck"> {{tck.deliveryDate | date:'MMM-dd-yy'}} </td>
      </tr>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="fishTicketColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: fishTicketColumns; let index=index;"></tr>

  </table>

</div>

<div *ngIf="fishery == 'HMS'" class="row">
  <h2 class="display-6" style="padding-left: 20px; text-decoration: underline; font-weight: 400;">Unloadings</h2>

  <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8">
    <!-- Species Column -->
    <ng-container matColumnDef="Species">
      <th style="border-right: none;" mat-header-cell *matHeaderCellDef> Species </th>
      <td style="border-right: none;" mat-cell *matCellDef="let element"> {{element.speciesName}} </td>
    </ng-container>

    <!-- Pounds Landed Column -->
    <ng-container matColumnDef="Pounds Landed">
      <th mat-header-cell *matHeaderCellDef> Pounds Landed </th>
      <td mat-cell *matCellDef="let element"> {{element.poundsLanded}} </td>
    </ng-container>

    <!-- Landing Receipt Column -->
    <ng-container matColumnDef="Landing Receipt">
      <th mat-header-cell *matHeaderCellDef> Landing Receipt </th>
      <td mat-cell *matCellDef="let element"> {{element.landingReceipt}} </td>
    </ng-container>

    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
          <mat-icon>
            {{expandedElement === element ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
          </mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Expanded Content Column -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
        <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <div style="display: flex; flex-direction: row; justify-content: space-around; padding-top: 10px; padding-bottom: 10px;">
            <div><strong>Port: </strong>{{element.unloadingPort}}</div>
            <div><strong>Date: </strong>{{element.unloadingDate | date:'MMM-dd-yy'}}</div>
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Header and Row Definitions -->
    <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;"
        class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"
        (click)="expandedElement = expandedElement === element ? null : element">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
  </table>

</div>

<div *ngIf="fishery == 'Trawl' && trawlLanding.atSeaDelivery" class="row">
  <mat-toolbar style="justify-content: center; background-color: #004165; color: whitesmoke;">
    <span>At-Sea Delivery to <span style="font-weight: bold; font-style: italic;">{{trawlLanding.mothershipName}}</span></span>
  </mat-toolbar>
</div>